<template>
    <div class="home-page cg-page">
		<!-- <Header></Header> -->
    <div class="pt20">
    <a class="logo" href="/#/index"><img src="static/images/logo1.png" /></a>
    </div>
		<div class="content mt50">
      <!-- <div class="">
        <div class="login-content">
          <div class="ac fs33 pt20" style="width:80%;margin:30px auto 30px;color:#f4fb2b;text-transform: uppercase;" v-html="$t('cgtips1')"></div>
          <div class="ac" style="color:#f4fb2b;width:80%;margin:0 auto 40px;">{{$t('cgtips2')}}</div>
          <div class="input-div">
            <div class="span fs33 fw7">{{$t('phoneNumber')}}</div>
            <div class="input-item">
              <input class="input" v-model="account" placeholder="">
            </div>
          </div>
          <div class="ac mt100">
            <button class="btn btn-blue" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b mt100">
            {{$t('cgtips3')}}
            <router-link class="fs33 opt-a " :to="{path:'/TC'}">{{$t('TC')}}</router-link>
            {{$t('cgtips4')}}
          </div>
        </div>
      </div> -->
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        account:'',
        password:'',

      }
    },
	created(){
    this.$parent.loadModal(true);
    if(this.$route.query.wifi==1){

    }else{
      if(this.$route.query.msisdn){
        this.account = this.$route.query.msisdn
        this.goLogin()
      }else{
        let timestamp = Math.round(new Date());
        let randomNum = 'MID'+timestamp+this.done(3, 3);
        let data = {
          transID:randomNum
        }
        this.$api.get('/api/user/he_log',data,r =>{

        })

        // window.location.href = 'http://gw.mygameempire.com/sshe/GAME_EMPIRE?transID='+randomNum
      }
    }
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
   done(len, max) {
      var arr = [];
      var result = "";
      var count = 0;
      while (count < len) {
        var n = Math.floor(Math.random() * max + 1);
        if (arr.join().indexOf(n) == -1) {
          arr.push(n);
          count++;
        }
      }
      for (let index = 0; index < arr.length; index++) {
        result = result + arr[index];
      }
      return result;
    },

		goLogin(){
		  let that = this
		  if(that.account==''){
		  	that.$utils.alertText(that.$t('tips'),60)
		  	return;
		  }
      let mobile = this.account

		  let data ={
		      'mobile':mobile,
          'transID':this.$route.query.transID
		      //'password':this.password,
		  }
		  that.$api.post('/api/user/check_user',data,r =>{
		  //	that.$parent.returnCode(r,function(){
		    if(r.code==1){
          if(r.data.is_register){
            localStorage.setItem('token',r.data.userinfo.token)
            that.isShowlogin = false
            that.account = ''
            this.$router.push({path:'/index'})
          }else{
             window.location.href = r.data.cg_url
            // this.$router.push({path:'/',query:{cg_url:r.data.cg_url}});
           // this.$router.push({path:'/sendOtp',query:{mobile:this.account,channel:this.$route.query.channel}});
          }

		    }else{
		      that.$utils.alertText(r.msg,80);
		    }
		      console.log(r.data.userinfo.token)
		  	//})
		  })
		},
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .input{background:none;height:70px;border:none;border-radius: 20px;font-size:38px;font-family:ChevinProBold;padding:0 20px;width:80%;color: #280933;}
  .input-div{margin:30px 40px 10px;}
  .input-div .span{margin: 0 auto 10px;width:70%;}
  .input-item{background:#ebe8f5;border-radius: 20px;height:80px;line-height:80px;width:70%;margin: 0 auto;background-image: linear-gradient(#ffffff,#dce9f2,#9dc0dc,#bbd3e5);
    border: 4px solid #ccc;}
  .input-div div span{font-size:38px;padding-left: 30px;color: #280933;}
  .mt100{margin-top:100px;}
  .opt-a{color: #2d31fa;text-decoration: underline;}
  .btn{line-height:80px;width:100%;color:#fff;width: 230px;}
  .cg-page{background:url(../../static/images/bg.jpg) repeat-y center top #7e00dd;color:#fff}
  .otp-b a{color:#fff}
  .login-content{color:#fff;}
</style>



// WEBPACK FOOTER //
// src/page/blank.vue